module.exports = __webpack_public_path__ + "static/media/toyota-street-selected.ff17f2c6.svg";